import React from "react";
import "./footer.css";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-quality">
      <div className="footer-container">

        <p className="footer-main-text">
          &copy; {year} BubUp. Todos los derechos reservados.
        </p>

        <div className="footer-contact-center">
          <span>Contacto:&nbsp;</span>
          <a href="mailto:contacto@bubup.com.mx">
            <i className="bi bi-envelope-fill"></i>
            <span className="footer-email-text">contacto@bubup.com.mx</span>
          </a>
        </div>

        <div className="footer-links">
          <a href="https://www.instagram.com" target="_blank" rel="noreferrer">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="https://wa.me/527711030518" target="_blank" rel="noreferrer">
            <i className="bi bi-whatsapp"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;